import * as Sentry from "@sentry/react"
import { Button } from "@/components/ui/button"

function FallbackUI() {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="text-center space-y-4">
        <h1 className="text-2xl font-bold">Something went wrong</h1>
        <p className="text-muted-foreground">Please try refreshing the page.</p>
        <Button onClick={() => window.location.reload()}>Refresh</Button>
      </div>
    </div>
  )
}

export const ErrorBoundary = Sentry.withErrorBoundary(
  ({ children }: { children: React.ReactNode }) => <>{children}</>,
  { fallback: <FallbackUI /> },
)
